import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import {
    TextField,
    MenuItem,
    InputAdornment,
    Modal,
    Box
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";

const CambiarSucursalModal = ({ open, onClose, idRegistro }) => {
    const [sucursal, setSucursal] = useState({
        idRegistro: idRegistro,
        sucursal: 0
    });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if(!open){
            return
        }
        onExecute();
    }, [open]);

    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`DashboardPostventa/GetSucursalServicio?id_registro=${idRegistro}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setSucursal(prev => ({
                        ...prev,
                        sucursal: result.idsucursal
                    }));
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };


    const guardarSucursal = () => {
        if (sucursal.sucursal === "" || sucursal.sucursal === null || sucursal.sucursal === undefined) {
            Swal.fire({
                title: "CAMBIAR SUCURSAL",
                text: "SE NECESITA SELECCIONAR UNA SUCURSAL",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }

        setLoader({ ...loader, mostrar: true });

        const post = {
            id_registro: idRegistro,
            idsucursal: sucursal.sucursal,
            usuario: 0
        };

        request
            .post(
                `DashboardPostventa/CambiarSucursalServicio`, post
            )
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                setSucursal({
                    ...sucursal,
                    sucursal: 0,
                })
                await Swal.fire({
                    title: "CAMBIAR SUCURSAL",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                onClose();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SERVICIOS PENDIENTES", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className="plantilla-screen-filtro-container-modal-container">
                <div className="cambiar-sucursal-cotizaciones-modal">
                    <div className="cambiar-sucursal-modal-detalle">
                        <div className="cambiar-sucursal-modal-detalle-formulario">
                            <div className="cambiar-sucursal-modal-formulario-plantilla">
                                <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                                    <PlantillaScreen
                                        titulo={`Cambiar sucursal`}
                                        className_main={1}
                                        className={"plantilla-screen-filtro-container-modal"}
                                    >
                                        <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                        <div
                                            className={`cambiar-sucursal-modal-formulario-plantilla-agregar`}
                                        >
                                            <div className="cambiar-sucursal-modal-formulario-plantilla-container scroll-4">
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Sucursal"
                                                    variant="outlined"
                                                    className="cel-2"
                                                    select
                                                    value={sucursal.sucursal}
                                                    onChange={(e) =>
                                                        setSucursal({
                                                            ...sucursal,
                                                            sucursal: e.target.value
                                                        })
                                                    }
                                                >
                                                    <MenuItem value={"1"}>Navolato</MenuItem>
                                                    <MenuItem value={"2"}>Tepic</MenuItem>
                                                    <MenuItem value={"11"}>Caimanero</MenuItem>
                                                    <MenuItem value={"12"}>San José</MenuItem>
                                                    <MenuItem value={"21"}>Eldorado</MenuItem>
                                                    <MenuItem value={"22"}>Santiago I.</MenuItem>
                                                    <MenuItem value={"31"}>Costa Rica</MenuItem>
                                                    <MenuItem value={"32"}>Tecuala</MenuItem>
                                                    <MenuItem value={"41"}>La Cruz</MenuItem>
                                                    <MenuItem value={"51"}>El Rosario</MenuItem>
                                                    <MenuItem value={"52"}>San Vicente</MenuItem>
                                                    <MenuItem value={"61"}>Villa Unión</MenuItem>
                                                </TextField>
                                            </div>
                                            <div className="cambiar-sucursal-modal-buttons">
                                                <button
                                                    className="cambiar-sucursal-modal-button-guardar"
                                                    onClick={() => guardarSucursal()}
                                                >
                                                    Guardar
                                                </button>
                                            </div>
                                        </div>
                                    </PlantillaScreen>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};


export default CambiarSucursalModal;